import styled from 'styled-components';

export const MinimizedContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;
